import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Route } from "react-router-dom";
import PostPageViewsPost from "./PostPageViewsPost";
import PostPageViewsTodoList from "./PostPageViewsTodoList";
import PostPageViewsTodo from "./PostPageViewsTodo";
const PostPage = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Route, {
                exact: true,
                path: "/leaf/:postId(\\d+)",
                component: PostPageViewsPost
            }),
            /*#__PURE__*/ _jsx(Route, {
                exact: true,
                path: "/todolist/:todoListId(\\d+)",
                component: PostPageViewsTodoList
            }),
            /*#__PURE__*/ _jsx(Route, {
                exact: true,
                path: "/todo/:todoId(\\d+)",
                component: PostPageViewsTodo
            })
        ]
    });
};
export default PostPage;
